import { Pipe, PipeTransform } from '@angular/core';
import { Supplier } from '../../classes/supplier';

@Pipe({
  name: 'supplierGlobalSearchFilter',
  pure: false
})
export class SupplierGlobalSearchFilterPipe implements PipeTransform {

  transform(supplierList: Array<Supplier>, filterValue: string): any {
    if (!supplierList || !filterValue) {
      return supplierList;
    }

    const normalizedFilter = filterValue.toLowerCase().trim();
    return supplierList.filter(supplier => {
      const id = String(supplier.IDSupplier ?? '').toLowerCase();
      const name = (supplier.Name || '').toLowerCase();
      const cf = (supplier.CF || '').toLowerCase();
      const email = (supplier.Email || '').toLowerCase();

      return id.indexOf(normalizedFilter) !== -1
        || name.indexOf(normalizedFilter) !== -1
        || cf.indexOf(normalizedFilter) !== -1
        || email.indexOf(normalizedFilter) !== -1;
    });
  }

}
